import { render, staticRenderFns } from "./userSettings.vue?vue&type=template&id=0b929227&scoped=true&"
import script from "./userSettings.vue?vue&type=script&lang=js&"
export * from "./userSettings.vue?vue&type=script&lang=js&"
import style0 from "./userSettings.vue?vue&type=style&index=0&id=0b929227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b929227",
  null
  
)

export default component.exports